import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { MotifTabControl, MotifTabNavigation } from '@ey-xd/motif-react';
import * as clientActions from '../../actions/clientActions';
import * as reitActions from '../../actions/reitActions';
import * as lookupTypeActions from '../../actions/lookupTypeActions';
import { withRouter } from '../../common/withRouter';
import { SubmissionError, reduxForm, reset } from 'redux-form';
import * as commonActions from '../../actions/commonActions';
import { Link } from 'react-router';
import * as masterDataManagementActions from '../../actions/masterDataManagementActions';
import MasterDataManagementHeader from '../../components/masterDataManagement/MasterDataManagementHeader';
import AddGroupModal from '../../components/masterDataManagement/AddGroupModal';
import GroupComponent from '../../components/masterDataManagement/GroupComponent';
import UploadGroupsModal from '../../components/masterDataManagement/UploadGroupsModal';
import CreateEditReitModal from '../../components/reits/createEditReitModal';
/**
 * MasterDataManagementContainer component
 * @extends {React.Component}
 */
class MasterDataManagementContainer extends Component {
  /**
   * Creates a new MasterDataManagementContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);

    this.state = {
      initialValues: null,
      lookupTypes: [],
      tabBar1: 0,
      groupsData: [],
      gridCurrentState: [],
      gridColumnState: [],
      refreshGridGroupData: {
        refreshGridOnCompletedAction: -1,
      },
      isAudit: false,
      showDeleteGroupConfirmationModal: false,
      showAddGroupModal: false,
      addGroupModalHeader: '',
      showEditGroupRowDataModal: false,
      selectedGroup: {
        EntityGroupID: 0,
        EntityGroupName: '',
        REITCount: 0,
      },
      showUploadGroupsModal: false,
    };

    this.setActiveTab = this.setActiveTab.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.setGridColumnState = this.setGridColumnState.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.handleAddGroups = this.handleAddGroups.bind(this);
    this.toggleShowAddGroupModal = this.toggleShowAddGroupModal.bind(this);
    this.handleSaveAddGroup = this.handleSaveAddGroup.bind(this);
    this.toggleShowDeleteGroupConfirmationModal =
      this.toggleShowDeleteGroupConfirmationModal.bind(this);
    this.handleDeleteButtonClick = this.handleDeleteButtonClick.bind(this);
    this.handleConfirmButtonClick = this.handleConfirmButtonClick.bind(this);
    this.handleEditButtonClick = this.handleEditButtonClick.bind(this);
    this.toggleShowEditGroupRowDataModal =
      this.toggleShowEditGroupRowDataModal.bind(this);
    this.handleDismissErrorMessage = this.handleDismissErrorMessage.bind(this);
    this.editGroup = this.editGroup.bind(this);
    this.handleCloseForm = this.handleCloseForm.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearValidationMessage = this.clearValidationMessage.bind(this);
    this.handleGroupEditSubmit = this.handleGroupEditSubmit.bind(this);
    this.handleUploadGroupImportTemplate =
      this.handleUploadGroupImportTemplate.bind(this);
    this.handleExportGroupImportTemplate =
      this.handleExportGroupImportTemplate.bind(this);
    this.handleDownloadMasterDataReport =
      this.handleDownloadMasterDataReport.bind(this);
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    const { clientId } = this.props;
    if (clientId) {
      this.props.masterDataManagementActions.fetchGroupsData(clientId);
      this.props.reitActions.fetchReitLookupTypes();
      this.getClientData();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.groupsData &&
      this.props.groupsData !== prevProps.groupsData
    ) {
      this.setState({ groupsData: this.props.groupsData });
    }
    // Handle client ID changes
    if (this.props.clientId !== prevProps.clientId) {
      this.fetchGroupsData();
    }
  }

  componentWillUnmount() {
    this.setState({ groupsData: [] });
  }

  getClientData() {
    this.props.clientActions.loadClient(this.props.clientId).then(() => {
      this.setState({ isAudit: this.props.isAudit });
    });
  }

  handleExportGroupImportTemplate() {
    this.props.masterDataManagementActions.exportGroupsData(
      this.props.clientId
    );
  }

  handleDownloadMasterDataReport() {
    this.props.masterDataManagementActions.exportAllTypesData(
      this.props.clientId
    );
  }
  //Set tab related state variables
  setActiveTab(currentIndex) {
    this.setState({
      activeTab: currentIndex,
      tabBar1: currentIndex,
    });
  }

  //Set current tab index based
  handleTabClick(index) {
    this.setActiveTab(index);
    if (index === 1) {
      // 1 is the index for Groups tab
      this.fetchGroupsData();
    }
  }
  fetchGroupsData() {
    const { clientId } = this.props;
    if (clientId) {
      this.props.masterDataManagementActions.fetchGroupsData(clientId);
    }
  }
  refreshGrid(selectedData = []) {
    this.fetchGroupsData();

    const randomNumber = parseInt(Math.random() * (99999999 - 1)) + 1;
    if (
      selectedData &&
      Array.isArray(selectedData) &&
      selectedData.length > 0
    ) {
      this.setState({
        refreshGridGroupData: {
          refreshGridOnCompletedAction: randomNumber,
        },
      });
    } else {
      this.setState({
        refreshGridGroupData: {
          refreshGridOnCompletedAction: randomNumber,
        },
      });
    }
  }
  handleAddGroups() {
    this.setState({
      showAddGroupModal: true,
      addGroupModalHeader: 'Add Group',
    });
  }

  toggleShowAddGroupModal() {
    this.props.dispatch(reset('addGroupForm'));
    this.setState({ validationMessage: '' });
    this.setState({ showAddGroupModal: !this.state.showAddGroupModal });
  }

  clearValidationMessage() {
    if (this.state.validationMessage != '') {
      this.setState({ validationMessage: '' });
    }
  }

  handleSaveAddGroup(values, saveAndAddAnother) {
    const group = {
      ClientID: this.props.clientId,
      EntityGroupName: values.groupName,
    };
    this.props.masterDataManagementActions
      .createGroup(group)
      .then((response) => {
        if (response && response.success) {
          this.props.masterDataManagementActions.fetchGroupsData(
            this.props.clientId
          );
          if (!saveAndAddAnother) {
            this.setState({ showAddGroupModal: !this.state.showAddGroupModal });
          }
          this.props.dispatch(reset('addGroupForm'));
          this.setState({ validationMessage: '' });
        }
        // Updated error message check for dynamic group name and client id
        else if (
          response &&
          response.errorMessage &&
          (response.errorMessage.includes('already exist') ||
            response.errorMessage.includes('already exists'))
        ) {
          this.setState({ validationMessage: 'Group Name already exists.' });
        }
      });
  }

  handleGridChanges(gridRowData) {
    let rowData = [];
    rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          EntityGroupID: x.EntityGroupID,
          EntityGroupName: x.EntityGroupName,
          REITCount: x.REITCount,
        };
      });
    this.setState({ gridCurrentState: rowData });
  }
  setGridColumnState() {
    var columnState = localStorage.getItem('REITSuiteGroupDataColumnState');
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }

  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  toggleShowDeleteGroupConfirmationModal() {
    this.setState({
      showDeleteGroupConfirmationModal:
        !this.state.showDeleteGroupConfirmationModal,
    });
  }

  handleDeleteButtonClick = (values) => {
    if (values) {
      this.setState({
        showDeleteGroupConfirmationModal: true,
        apiErrorMessage: '', // Clear any previous error message,
        selectedGroup: {
          EntityGroupID: values.entityGroupID,
          EntityGroupName: values.entityGroupName,
          REITCount: values.reitCount,
        },
      });
    }
  };

  handleConfirmButtonClick = (values) => {
    if (values) {
      this.props.masterDataManagementActions
        .deleteEntityGroup(
          this.props.clientId,
          this.state.selectedGroup.EntityGroupID
        )
        .then((response) => {
          if (response && response.success) {
            this.setState({
              showDeleteGroupConfirmationModal: false,
              selectedGroup: null,
              apiErrorMessage: '', // Clear any previous error message
            });
            this.fetchGroupsData();
          } else {
            this.setState({
              apiErrorMessage:
                response.errorMessage ||
                'An error occurred while deleting the group.',
            });
          }
          // this.setState({ showDeleteGroupConfirmationModal: false });
        })
        .catch((error) => {
          this.setState({
            apiErrorMessage: error.message || 'An unexpected error occurred.',
          });
        });
    }
  };

  handleCloseForm() {
    this.setState({
      showEditGroupRowDataModal: false,
      selectedGroup: {
        EntityGroupID: 0,
        EntityGroupName: '',
        REITCount: 0,
      },
    });
  }
  handleEditButtonClick = (values) => {
    this.clearValidationMessage();
    if (values) {
      (this.props.dispatch(reset('editGroupForm')),
        this.setState({
          showEditGroupRowDataModal: true,
          selectedGroup: {
            EntityGroupID: values.entityGroupID,
            EntityGroupName: values.entityGroupName,
            REITCount: values.reitCount,
          },
        }));
    }
  };
  toggleShowEditGroupRowDataModal() {
    this.setState({
      showEditGroupRowDataModal: !this.state.showEditGroupRowDataModal,
    });
  }
  handleDismissErrorMessage() {
    this.props.commonActions.clearFormErrors('editGroupForm');
  }

  handleSubmit(values, e) {
    let groupToHandle = Object.assign({}, values);
    return this.handleGroupEditSubmit(groupToHandle);
  }

  handleGroupEditSubmit(values) {
    this.props.commonActions.beginTask();
    if (this.props.clientId === 0) {
      throw new SubmissionError({
        _error: 'A GROUP must be associated with a client.',
      });
    }
    const group = {
      ClientID: this.props.clientId,
      EntityGroupID: values.EntityGroupID,
      EntityGroupName: values.EntityGroupName,
    };

    return this.editGroup(group);
  }

  editGroup(group) {
    return masterDataManagementActions
      .updateEntityGroup(group)
      .then((response) => {
        if (response && response.success) {
          this.handleCloseForm();
          this.props.commonActions.endTask();
          this.refreshGrid();
          this.setState({ validationMessage: '' });
        }
        // Updated error message check for dynamic group name and client id
        else if (
          response &&
          response.errorMessage &&
          (response.errorMessage.includes('already exist') ||
            response.errorMessage.includes('already exists'))
        ) {
          this.props.commonActions.endTask();
          this.setState({ validationMessage: 'Group Name already exists.' });
        }
      });
  }

  handleUploadGroupImportTemplate() {
    this.setState({ showUploadGroupsModal: true });
  }

  toggleUploadGroupsModal = () => {
    this.setState({ showUploadGroupsModal: !this.state.showUploadGroupsModal });
    this.props.masterDataManagementActions.fetchGroupsData(this.props.clientId);
  };

  render() {
    const { masterData } = this.props;

    return (
      <div>
        <h2 data-testid="pghdrMasterDataManagement">Master Data Management</h2>

        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/groups`}
            tabIndex="-1"
          >
            <MotifTabControl
              className="motif-active"
              role="tab"
              onClick={() => this.handleTabClick(1)}
              data-testid="tbGroups"
            >
              Groups
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/reits`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(2)}
              data-testid="tbREITs"
            >
              REITs
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/properties`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(3)}
              data-testid="tbProperties"
            >
              Properties
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/securities`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(4)}
              data-testid="tbSecurities"
            >
              Securities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/masterDataManagement/trs`}
            tabIndex="-1"
            hidden={this.props.isAudit}
          >
            <MotifTabControl
              role="tab"
              onClick={() => this.handleTabClick(5)}
              data-testid="tbTrs"
            >
              Taxable REIT Subsidiaries
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>
        <MasterDataManagementHeader
          handleAddGroups={this.handleAddGroups}
          handleUploadGroupImportTemplate={this.handleUploadGroupImportTemplate}
          handleExportGroupImportTemplate={this.handleExportGroupImportTemplate}
          handleDownloadMasterDataReport={this.handleDownloadMasterDataReport}
        />
        <AddGroupModal
          showAddGroupModal={this.state.showAddGroupModal}
          toggleShowAddGroupModal={this.toggleShowAddGroupModal}
          addGroupModalHeader={this.state.addGroupModalHeader}
          handleSaveAddGroup={this.handleSaveAddGroup}
          validationMessage={this.state.validationMessage}
          clearValidationMessage={this.clearValidationMessage}
        ></AddGroupModal>
        {this.state.showUploadGroupsModal && (
          <UploadGroupsModal
            show={this.state.showUploadGroupsModal}
            onClose={this.toggleUploadGroupsModal}
          />
        )}
        <GroupComponent
          groupsData={this.props.groupsData}
          showEditGroupRowDataModal={this.state.showEditGroupRowDataModal}
          handleCloseForm={this.handleCloseForm}
          editGroup={this.editGroup}
          selectedGroup={this.state.selectedGroup}
          handleEditButtonClick={this.handleEditButtonClick}
          handleDismissErrorMessage={this.handleDismissErrorMessage}
          handleGridChanges={this.handleGridChanges}
          gridColumnState={this.gridColumnState}
          handleGridColumnStateChange={this.handleGridColumnStateChange}
          refreshGridGroupData={this.refreshGridGroupData}
          handleDeleteButtonClick={this.handleDeleteButtonClick}
          handleConfirmButtonClick={this.handleConfirmButtonClick}
          showDeleteGroupConfirmationModal={
            this.state.showDeleteGroupConfirmationModal
          }
          toggleShowDeleteGroupConfirmationModal={
            this.toggleShowDeleteGroupConfirmationModal
          }
          gridCurrentState={this.state.gridCurrentState}
          toggleShowEditGroupRowDataModal={this.toggleShowEditGroupRowDataModal}
          handleSubmit={this.handleSubmit}
          validationMessage={this.state.validationMessage}
          clearValidationMessage={this.clearValidationMessage}
          apiErrorMessage={this.state.apiErrorMessage}
        />
      </div>
    );
  }
}

MasterDataManagementContainer.propTypes = {
  clientId: PropTypes.number,
  reitActions: PropTypes.object,
  clientActions: PropTypes.object,
  lookupTypeActions: PropTypes.object,
  lookupTypes: PropTypes.object,
  isAudit: PropTypes.bool,
  commonActions: PropTypes.object.isRequired,
  masterData: PropTypes.object,
  groupsData: PropTypes.array,
  masterDataManagementActions: PropTypes.object,
  dispatch: PropTypes.func,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  let cid = Number.parseInt(ownProps.router.params.clientId);
  if (isNaN(cid)) {
    cid = 0;
  }
  return {
    masterData: state.masterData,
    clientId: cid,
    isAudit: state.client && state.client.isAudit,
    lookupTypes: state.lookupTypes,
    groupsData: state.groupsData,
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(masterDataManagementActions, dispatch),
    masterDataManagementActions: bindActionCreators(
      masterDataManagementActions,
      dispatch
    ),
    clientActions: bindActionCreators(clientActions, dispatch),
    reitActions: bindActionCreators(reitActions, dispatch),
    lookupTypeActions: bindActionCreators(lookupTypeActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'masterDataManagementForm',
      enableReinitialize: true,
    })(MasterDataManagementContainer)
  )
);
